import React, { Component } from "react";
//import PropTypes from 'prop-types'
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import "moment/locale/nl";
import "moment/locale/en-gb";
import "moment/locale/de";
import DateTimePickerInput from "./DateTimePickerInput";

export default class DateTimePicker extends Component {
  constructor(props) {
    super(props);
    this.container = React.createRef();
    this.datetimepicker = React.createRef();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state !== nextState) return true;
    if (!nextProps.value || !this.props.value) {
      return nextProps.value !== this.props.value;
    }

    const valueDiff =
      this.props.value.toString() !== nextProps.value.toString();
    return valueDiff;
  }

  componentDidMount() {
    const { value, displayFormat, onChange, valueFormat } = this.props;
    const momentValue = moment(value, valueFormat);
    if (onChange && momentValue.isValid()) {
      onChange(value, momentValue.format(displayFormat));
    }
  }

  render() {
    const props = Object.assign(
      {},
      {
        readOnly: false,
        hasIndicator: true,
        fixedHeight: true,
      },
      this.props
    );
    let {
      valueFormat,
      inputFormat,
      displayFormat,
      locale,
      value,
      label,
      name,
      readOnly,
      disabled,
      minDate,
      maxDate,
      invalidDate,
    } = props;
    label = label || name;
    inputFormat = inputFormat || valueFormat;
    displayFormat = displayFormat || inputFormat || valueFormat;

    const momentValue = value ? moment(value, valueFormat, true) : null;
    moment.locale(locale || "en-gb");

    return (
      <div className="react-datepicker__container" ref={this.container}>
        <ReactDatePicker
          dateFormat={valueFormat}
          ref={this.datetimepicker}
          customInput={
            <DateTimePickerInput
              container={this.container}
              datetimepicker={this.datetimepicker}
              hasIndicator={props.hasIndicator}
              locale={locale}
              label={label}
              minDate={minDate}
              maxDate={maxDate}
              aria-required={!!props["aria-required"]}
              inputIsReadOnly={!!props.readOnly}
              disabled={disabled}
              valueFormat={valueFormat}
              inputFormat={inputFormat}
              displayFormat={displayFormat}
              value={value}
              invalidDate={invalidDate}
              onChangeRaw={(e) => {
                const value = e.target.value;
                //console.log('Picker onChangeRaw: ', value)
                if (props.onChange) props.onChange(value);
              }}
            />
          }
          isClearable={false}
          popperPlacement="top-end"
          openToDate={
            momentValue && momentValue.isValid() ? momentValue : moment()
          }
          {...props}
          inputIsReadOnly={readOnly}
          selected={momentValue && momentValue.isValid() ? momentValue : null}
          adjustDateOnChange={false} //Conflicts with the input focus state
          onChange={(momentValue) => {
            //console.log('Picker change: ', momentValue)
            const value =
              momentValue && momentValue.isValid()
                ? momentValue.format(valueFormat)
                : "";
            const displayValue =
              momentValue && momentValue.isValid()
                ? momentValue.format(displayFormat)
                : "";
            //console.log('Picker change cleaned: ', value)
            if (props.onChange) props.onChange(value, displayValue);
            if (props.onBlur) props.onBlur();
          }}
          onBlur={(e) => {
            props.onBlur(e);
          }}
          onClickOutside={(e) => {
            if (props.onBlur) props.onBlur();
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Common/DateTimePicker.js